import React from "react";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

export default class DateRange extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFrom: props.dateFrom,
      dateTo: props.dateTo,
      width: props.width,
    };
  }

  render() {
    let { dateFrom, dateTo, width } = this.state;

    let cssClass = "col-lg-3";
    if (width === "full") {
      cssClass = "col";
    }

    return (
      <div className="row mb-4">
        <div className={cssClass}>
          <div className="input-group pull-right">
            <Flatpickr
              value={dateFrom ? dateFrom.format("DD-MM-YYYY") : null}
              className="form-control"
              placeholder="From"
              options={{
                enableTime: false,
                noCalendar: false,
                dateFormat: "d-m-Y",
                maxDate: "today",
              }}
              onChange={(dates) => {
                const date = moment.utc(moment(dates[0]).format("YYYY-MM-DD"))
                this.setState(
                  {
                    dateFrom: date,
                  },
                  () => this.props.onFromDateUpdated(moment(date))
                );
              }}
            />
          </div>
        </div>
        <div className={cssClass}>
          <div className="input-group pull-right">
            <Flatpickr
              value={dateTo ? dateTo.format("DD-MM-YYYY") : null}
              className="form-control"
              placeholder="To"
              options={{
                minDate: dateFrom ? dateFrom.format("DD-MM-YYYY") : null,
                enableTime: false,
                noCalendar: false,
                dateFormat: "d-m-Y",
                maxDate: "today",
              }}
              onChange={(dates) => {
                const date = moment.utc(moment(dates[0]).format("YYYY-MM-DD"))
                this.setState(
                  {
                    dateTo: date,
                  },
                  () => this.props.onToDateUpdated(date)
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
